module.exports = __webpack_public_path__ + "img/black-week-default-rodape.a7594529.webp";